import all_by_age from "../../public/all_groupedby_age.json";
import all_by_region from "../../public/all_groupedby_region.json";
import all_by_week from "../../public/all_groupedby_week.json";
import sequenced_by_age from "../../public/seq_groupedby_age.json";
import sequenced_by_region from "../../public/seq_groupedby_region.json";
import sequenced_by_week from "../../public/seq_groupedby_week.json";
import sequenced_by_lineage_week from "../../public/seq_groupedby_lineage_week.json"
import sequenced_by_lineage_age from "../../public/seq_groupedby_lineage_age.json"
import sequenced_by_lineage_region from "../../public/seq_groupedby_lineage_region.json"

import { get_colors } from "../preprocessing/color_generator"
import lodash from 'lodash'

export function get_number_of_all_samples(){	
	let cases = 0
	all_by_week.forEach(e => cases += e.cases)
	return cases
}

export function get_number_of_sequenced_samples(){
	let cases = 0
	sequenced_by_lineage_region.forEach(e => cases += e.cases)
	console.log(cases)

	cases = 0
	sequenced_by_lineage_age.forEach(e => cases += e.cases)
	console.log(cases)

	cases = 0
	sequenced_by_lineage_region.forEach(e => cases += e.cases)
	console.log(cases)
	return cases
}

export function get_week_graph_data(option){
  return get_graph_obj(all_by_week, sequenced_by_week, "week", option, _week_num_to_date_str);
}

export function get_age_graph_data(option){
  return get_graph_obj(all_by_age,sequenced_by_age, "age_group", option);
}

export function get_region_graph_data(option){
  return get_graph_obj(all_by_region,sequenced_by_region, "region", option);
}

export function get_week_lineage_graph_data(option){
	return get_lineage_graph_obj(sequenced_by_lineage_week, "week", option, _get_lineage_week_labels, _week_num_to_date_str);
}

export function get_age_lineage_graph_data(option){
	return get_lineage_graph_obj(sequenced_by_lineage_age, "age_group", option, _get_lineage_age_labels);
}

export function get_region_lineage_graph_data(option){
	return get_lineage_graph_obj(sequenced_by_lineage_region, "region", option, _get_lineage_region_labels);
}

function get_graph_obj(arr_all, arr_seq, key, option, label_formatting_func = x => x) {

	arr_all = _get_time_interval(arr_all, key, option)
	arr_seq = _get_time_interval(arr_seq, key, option)
	let graph_data = merge_all_sequenced_data(arr_all, arr_seq, key)

  let labels = [];
  let data_all = [];
  let data_seq = []
  graph_data.forEach((e) => {
			let label = label_formatting_func(e["label"])
      labels.push(label);
      data_all.push(e["data_all"]);
      data_seq.push(e["data_seq"]);
	});
	let colors = get_colors(2)
  return {
    "labels":labels,
    "datasets":[
      {
        label:"All cases",
        backgroundColor: colors[0], 
        data:data_all
      },
      {
        label:"Sequenced cases",
        backgroundColor: colors[1], 
        data:data_seq
      }
    ]
  }
}

function get_lineage_graph_obj(arr, key, option, label_func, label_formatting_func = x => x){
	
	arr = _get_lineage_time_interval(arr, key, option)
	let arr_sorted = _sort_arr_by_lineage(arr)
	let labels = _get_labels_from_func(arr, key, label_func)
	let datasets = _split_by_lineage(arr_sorted, key)
	let colors = get_colors(datasets.length)
	
	let processed_datasets = []
	datasets.forEach((e,i) => {
		processed_datasets.push({
			"label":e[0]["lineage"],
			"data":_fill_blanks(e, labels, key),
			"backgroundColor": colors[i]		
		})
	})
	return {
		"labels":	 labels.map(label_formatting_func),
    "datasets":processed_datasets
	}
}

function merge_all_sequenced_data(arr_all, arr_seq, key){
  let res = [];
  arr_all.forEach((e, i) => {
    if (e[key] !== undefined && e[key] !== "" && e[key] !== null && e[key] !== "null") {
      res.push({
        label: arr_all[i][key],
        data_all: arr_all[i]["cases"],
      });
    }
  });

  arr_seq.forEach((e) => {
    let found = false;
    res.forEach((res_e, j) => {
      if (e[key] === res_e["label"]) {
        res[j]["data_seq"] = e["cases"];
        found = true;
      }
    });
    if (found === false && e[key] !== undefined && e[key] !== "" && e[key] !== null && e[key] !== "null") {
      res.push({
        label: e[key],
        data_all: 0,
        data_seq: e["cases"],
      });
    }
  });
  return res;
}

function _get_lineage_time_interval(sequence, key, option){
	let is_month = option.includes("month")
	if(is_month === false){	
		return _merge_lineage_weeks(sequence, key)
	}

	let filtered_sequence = []
	sequence.forEach(e => {
		let current_year = new Date().getFullYear() //replace with actual year information in the sequence (otherwise this will not work in 2021,..)
		let week_end_date = _getDateOfISOWeek(e["week"], current_year)
		let interval_start_date = new Date();
		interval_start_date.setDate(interval_start_date.getDate()-60); //TODO: Set this back to 30
		
		if(week_end_date > interval_start_date){
			filtered_sequence.push(e)
		}
	})

	return _merge_lineage_weeks(filtered_sequence, key)
}

function _get_time_interval(sequence, key, option){
	let is_month = option.includes("month")
	if(is_month === false){	
		return _merge_weeks(sequence, key)
	}

	let filtered_sequence = []
	sequence.forEach(e => {
		let current_year = new Date().getFullYear() //replace with actual year information in the sequence (otherwise this will not work in 2021,..)
		let week_end_date = _getDateOfISOWeek(e["week"], current_year)
		let interval_start_date = new Date();
		interval_start_date.setDate(interval_start_date.getDate()-60); //TODO: Set this back to 30
		
		if(week_end_date > interval_start_date){
			filtered_sequence.push(e)
		}
	})

	return _merge_weeks(filtered_sequence, key)
}

function _merge_weeks(sequence, key){
	let result = []
	let groupd_by_week = lodash.groupBy(sequence, key)
	for(let key_val in groupd_by_week){
		let cases = 0
		groupd_by_week[key_val].forEach(e => {
			cases += e["cases"]
		})
		result.push({
			[key]:key_val,
			"cases":cases
		})
	}
	return result
}

function _conver_key_val_to_proper_type(key, keyvalue){
	switch (key) {
		case "week":
			return parseInt(keyvalue)
		default:
			return keyvalue
	}
}

function _merge_lineage_weeks(sequence, key){
	let result = []
	let grouped_by_key = lodash.groupBy(sequence, key)
	for(let key_val in grouped_by_key){
		let grouped_by_key_lineage = lodash.groupBy(grouped_by_key[key_val], "lineage")
		let cases = 0
		for (let key_lineage_val in grouped_by_key_lineage) {
			grouped_by_key_lineage[key_lineage_val].forEach(e => {
				cases += e["cases"]
			})
			result.push({
				[key]: _conver_key_val_to_proper_type(key, key_val),
				"lineage":key_lineage_val,
				"cases": cases
			})
		}
	}
	return result
}

function _getDateOfISOWeek(w, y) {
	var simple = new Date(y, 0, 1 + (w - 1) * 7);
	var dow = simple.getDay();
	var ISOweekStart = simple;
	if (dow <= 4)
			ISOweekStart.setDate(simple.getDate() - simple.getDay() + 1);
	else
			ISOweekStart.setDate(simple.getDate() + 8 - simple.getDay());
	ISOweekStart.setDate(ISOweekStart.getDate() + 6);
	return ISOweekStart
}
	
function _get_lineage_week_labels(arr, key){
	let labels = []
	arr.forEach(e => {
		labels.push(e[key])
	})
	let min_week = Math.min(...labels)
	let max_week = Math.max(...labels)
	let result = []
	for(let i=min_week; i<=max_week; i++){
		result.push(i)
	}
	return result
}

function _get_lineage_region_labels(){
	return ["Hovedstaden", "Midtjylland", "Nordjylland", "Sj\u00e6lland", "Syddanmark"]
}

function _get_lineage_age_labels(){
	let labels = []
	for(let i = 0;i<=8;i++){
		labels.push(`${i*10}-${i*10+9}`)
	}
	labels.push("90+")
	return labels
}

function _fill_blanks(arr, labels, key){
	arr.push({key:-1})
	let result = []
	let idx = 0
	labels.forEach(label => {
		if(label === arr[idx][key]){
			result.push(arr[idx]["cases"])
			idx++
		}
		else{
			result.push(0)
		}
	})
	return result
}

function _split_by_lineage(arr, key){
	let cur_key = null
	let datasets = []
	let labels = new Set()
	let dataset = []
	arr.forEach(e => {
		if(cur_key === null){
			cur_key = e["lineage"]
		}

		if(e["lineage"] !== cur_key){
			datasets.push(dataset)
			dataset = []
			cur_key = e["lineage"]
		}
		dataset.push(e)
		labels.add(e[key])
	})
	datasets.push(dataset)
	return datasets	
}

function _get_labels_from_func(arr, key, label_func){
	if (label_func.length == 2){
		return label_func(arr, key)
	}
	return label_func()
}

function _sort_arr_by_lineage(arr){
	arr.sort(function(a,b){
		if(a["lineage"] < b["lineage"]) { return -1; }
    if(a["lineage"] > b["lineage"]) { return 1; }
    return 0;
	});
	return arr
}

function _week_num_to_date_str(week){
	let date = _getDateOfISOWeek(week, 2020)
	return date.toLocaleDateString('de-DE')
}